import type { Maybe } from '@/types/globals';
import { Pipe, PipeTransform } from '@angular/core';
import { GenderType } from '@shared/models/enums/enums';

@Pipe({ name: 'gender', standalone: true })
export class GenderPipe implements PipeTransform {
	transform(gender?: Maybe<number>): string {
		if (gender === null || gender === undefined) {
			return GenderType.Empty;
		}

		return GenderType[gender] ? GenderType[gender].toString() : GenderType.Empty;
	}
}
